import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getStoresAdapter } from "@/features/stores/adapters/get-stores";
import { isAuthenticated } from "@/lib/auth-utils";

export const Route = createFileRoute("/_auth/_auth-layout")({
	beforeLoad: async ({ location }) => {
		if (
			location.pathname === "/forgot-password" ||
			location.pathname === "/reset-password"
		) {
			return;
		}

		const authenticated = await isAuthenticated();
		if (authenticated) {
			const stores = await getStoresAdapter();
			if (stores.length > 0) {
				throw redirect({
					to: "/$store",
					params: { store: stores[0].slug },
				});
			}
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
			<div className="w-full max-w-sm">
				<Outlet />
			</div>
		</div>
	);
}
